module.exports = __webpack_public_path__ + "static/media/upload.35c9a355.png";